import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';
import EventStock from '@js/franchise_component/franchise-inventory/stock/stock-event';
import Auth from '@js/plugins/auth';
import m from 'moment';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const varianceTypes = [
    { id: 3, name: 'Stock Sold' },
    { id: 4, name: 'Stock Wastage' },
    { id: 5, name: 'Stock Damage' },
    { id: 6, name: 'Stock Stolen / Loss' },
    { id: 7, name: 'Incorrect Counting' },
    { id: 8, name: 'Overtopping' },
    { id: 9, name: 'Other' },
];

const state = {
    stock_movement: {
        outlet_id: null,
        reference_id: null,
        name: null,
        status: null,
        outlet_name: null,
        settled_at: null,
        settled_by: null,
        settled_name: null,
        created_by: null,
        created_name: null,
        supplier: {
            name: null,
            stocks: [],
        },
        enable_unscanned_items: false,
    },
    stock_movement_products: [],
    custom_reason: false,
    subUnscannedItems: [],
    checkSubCategoryValue: [],
    checkCategoryValue: [],
    hasUnscannedItems: {
        session: null,
        status: false,
    },
    stationStockSalesCategories: [],
    salesCategoryValue: [],
    requireRefreshUnscannedStock: false,
    selectedSubCategory: [],
    selectedCategory: [],
    selectedAll: false,
    availableSalesCategories: [],
    oldAuditSalesCategoryValue: [],
    excludeSalesCategoryId: [],
};

const getters = {
    varianceTypes() {
        return varianceTypes;
    },

    stockMovement: state => state.stock_movement,

    hasFinalized: state => state.stock_movement.status == 2,

    completionStatus(state) {
        if (state.stock_movement.status == 2) {
            return 'Completed';
        }

        return 'In Progress';
    },

    stockMovementProducts: state =>
        state.stock_movement_products.map((p, i) => {
            p.row_index = i + 1;
            return p;
        }),

    findStockIndex: (state, getters) => stock_id => {
        return getters.stockMovementProducts.findIndex(
            s => s.stock_id == stock_id,
        );
    },

    customReason: state => state.custom_reason,

    totalSystemQty: (state, getters) => {
        return getters.stockMovementProducts
            .map(product => {
                return parseFloat(product.quantity_before);
            })
            .reduce((a, b) => a + b, 0);
    },

    totalCountedQty: (state, getters) => {
        return getters.stockMovementProducts
            .map(product => {
                const validQty =
                    !_.isNaN(product.quantity_after) &&
                    !_.isNull(product.quantity_after) &&
                    !_.isEmpty(product.quantity_after);

                return validQty ? parseFloat(product.quantity_after) : 0;
            })
            .reduce((a, b) => a + b, 0);
    },

    totalVariance: (state, getters) => {
        const variance = getters.stockMovementProducts.map(product => {
            return (
                parseFloat(product.quantity_after) -
                parseFloat(product.quantity_before)
            );
        });

        return variance.reduce((a, b) => a + b, 0);
    },

    totalCost: (state, getters) => {
        return getters.stockMovementProducts
            .map(product => {
                if (!_.isEmpty(product.quantity_after)) {
                    return (
                        (product.quantity_after - product.quantity_before) *
                        product.supplier_price
                    );
                }

                return 0;
            })
            .reduce((a, b) => a + b, 0);
    },

    totalPriceVar: (state, getters) => {
        return getters.stockMovementProducts
            .map(product => {
                if (!_.isEmpty(product.quantity_after)) {
                    return (
                        (product.quantity_after - product.quantity_before) *
                        product.rsp
                    );
                }

                return 0;
            })
            .reduce((a, b) => a + b, 0);
    },

    productCount: (state, getters) => {
        if (getters.stockMovementProducts.length !== 0) {
            return `Total: ${getters.stockMovementProducts.length}`;
        }

        return '';
    },

    subUnscannedItems: state => state.subUnscannedItems,

    checkSubCategoryValue: state => state.checkSubCategoryValue,

    checkCategoryValue: state => state.checkCategoryValue,

    hasUnscannedItems: state => state.hasUnscannedItems,

    stationStockSalesCategories: state => state.stationStockSalesCategories,

    salesCategoryValue: state => state.salesCategoryValue,

    requireRefreshUnscannedStock: state => state.requireRefreshUnscannedStock,

    flatSubUnscannedItems: state => {
        return _.flatMapDeep(
            state.subUnscannedItems.map(d => {
                return _.flatMap(d).map(d => {
                    return _.flatMap(d);
                });
            }),
        );
    },

    selectedSubCategory: state => state.selectedSubCategory,

    selectedCategory: state => state.selectedCategory,

    selectedAll: state => state.selectedAll,

    availableSalesCategories: state => state.availableSalesCategories,

    oldAuditSalesCategoryValue: state => state.oldAuditSalesCategoryValue,

    excludeSalesCategoryId: state => state.excludeSalesCategoryId,
};

const mutations = {
    [types.SET_STOCK_MOVEMENT](state, data) {
        state.stock_movement = data;
    },

    setStockMovement(state, data) {
        state.stock_movement = data;
    },

    [types.SET_STOCK_MOVEMENT_ATTR](state, { key, value }) {
        state.stock_movement[key] = value;
    },

    [types.ADD_STOCK_MOVEMENT_PRODUCT](state, counted_stock) {
        state.stock_movement_products.push(counted_stock);
    },

    [types.UPDATE_STOCK_MOVEMENT_PRODUCT](state, { stockIndex, attr, value }) {
        state.stock_movement_products[stockIndex][attr] = value;
    },

    [types.REMOVE_STOCK_MOVEMENT_PRODUCT_DETAIL](
        state,
        { stock_id, variance },
    ) {
        const checkedStock = state.stock_movement_products.find(
            s => s.stock_id == stock_id,
        );

        if (!_.isUndefined(checkedStock)) {
            const removeIndex = checkedStock.stock_movement_product_details.findIndex(
                v => v.type == variance.type,
            );

            checkedStock.stock_movement_product_details.splice(removeIndex, 1);
        }
    },

    [types.SAVE_STOCK_MOVEMENT_PRODUCT_DETAIL](state, variance) {
        const checkedStock = state.stock_movement_products.find(
            s => s.stock_id == variance.stock_id,
        );

        if (!_.isUndefined(checkedStock)) {
            checkedStock.stock_movement_product_details.push(variance);
        }
    },

    [types.REMOVE_STOCK_MOVEMENT_PRODUCT](state, stockIndex) {
        state.stock_movement_products.splice(stockIndex, 1);
    },

    merge(state, data) {
        state.stock_movement.stock_movement_products = data;
    },

    setStockMovementProducts(state, data) {
        state.stock_movement_products = data;
    },

    setCustomReason(state, data) {
        state.custom_reason = data;
    },

    setCommitBy(state) {
        state.stock_movement.settled_by = Auth.user().id;
        state.stock_movement.settled_name = Auth.user().name;
        state.stock_movement.settled_at = m();
    },

    setResetCommit(state) {
        state.stock_movement.settled_by = null;
        state.stock_movement.settled_name = null;
        state.stock_movement.settled_at = null;
    },

    setSubUnscannedItems(state, data) {
        state.subUnscannedItems.push(data);
    },

    clearSubUnscannedItems(state) {
        state.subUnscannedItems = [];
    },

    addCheckSubCategoryValue(state, data) {
        if (!state.checkSubCategoryValue.includes(data)) {
            state.checkSubCategoryValue.push(data);
        }
    },

    removeCheckSubCategoryValue(state, data) {
        let index = state.checkSubCategoryValue.findIndex(i => i == data);

        if (index != -1) {
            state.checkSubCategoryValue.splice(index, 1);
        }
    },

    addCheckCategoryValue(state, data) {
        if (!state.checkCategoryValue.includes(data)) {
            state.checkCategoryValue.push(data);
        }
    },

    removeCheckCategoryValue(state, data) {
        let index = state.checkCategoryValue.findIndex(i => i == data);

        if (index != -1) {
            state.checkCategoryValue.splice(index, 1);
        }
    },

    setHasUnscannedItems(state, data) {
        state.hasUnscannedItems = data;
    },

    setStationStockSalesCategories(state, data) {
        state.stationStockSalesCategories = data;
        state.stationStockSalesCategories.unshift({
            category: 'select_all',
            sub_category: [
                {
                    name: 'SELECT ALL',
                    id: 0,
                },
            ],
        });
    },

    setSalesCategoryValue(state, { data, onLoad = false }) {
        if (!onLoad) {
            state.salesCategoryValue.push(data);

            if (
                state.stationStockSalesCategories.length -
                    state.salesCategoryValue.length ==
                1
            ) {
                state.salesCategoryValue.push({
                    id: 0,
                    name: 'SELECT ALL',
                });
            }
        } else {
            state.salesCategoryValue = [];
            state.salesCategoryValue = data.selected_sub_category;
            state.selectedSubCategory = data.selected_sub_category;
            state.selectedCategory = data.selected_category;

            let filter = data.selected_sub_category.filter(
                f => f.unscanned_count == f.flag_count,
            );

            if (!_.isEmpty(filter)) {
                _.map(filter, 'grouped').map(d => {
                    if (!state.checkSubCategoryValue.includes(d)) {
                        state.checkSubCategoryValue.push(d);
                    }
                });
            }

            let mainFilter = data.selected_category.filter(
                f => f.unscanned_count == f.flag_count,
            );

            if (!_.isEmpty(mainFilter)) {
                _.map(mainFilter, 'id').map(d => {
                    if (!state.checkCategoryValue.includes(d)) {
                        state.checkCategoryValue.push(d);
                    }
                });
            }
        }
    },

    removeSalesCategoryValue(state, { index, all = false }) {
        if (all) {
            state.salesCategoryValue = [];
        } else {
            if (index != -1) {
                state.salesCategoryValue.splice(index, 1);

                let i = state.salesCategoryValue.findIndex(f => f.id == 0);

                if (i != -1) {
                    state.salesCategoryValue.splice(i, 1);
                }
            }
        }
    },

    addSalesCategoryId(state, id) {
        if (state.excludeSalesCategoryId == 'remove_all') {
            state.excludeSalesCategoryId = [];
        }

        if (id != 0) {
            let index = state.excludeSalesCategoryId.findIndex(f => f == id);

            if (index != -1) {
                state.excludeSalesCategoryId.splice(index, 1);
            }
        } else {
            state.excludeSalesCategoryId = [];
        }
    },

    removeSalesCategoryId(state, id) {
        if (id != 0) {
            state.excludeSalesCategoryId.push(id);
        } else {
            state.excludeSalesCategoryId = 'remove_all';
        }
    },

    setRequireRefreshUnscannedStock(state, data) {
        state.requireRefreshUnscannedStock = data;
    },

    removeUnscannedStock(state, index) {
        let stock = _.flatMapDeep(
            state.subUnscannedItems.map(d => {
                return _.flatMap(d).map(d => {
                    return _.flatMap(d);
                });
            }),
        )[index];

        if (stock) {
            state.subUnscannedItems
                .find(d => d[stock.parent_id])
                [stock.parent_id][stock.grouped].splice(index, 1);
        }
    },

    clearData(state) {
        state.subUnscannedItems = [];
        state.checkSubCategoryValue = [];
        state.checkCategoryValue = [];
        state.salesCategoryValue = [];
        state.reRefreshUnscannedStock = false;
        state.selectedSubCategory = [];
        state.selectedCategory = [];
        state.selectedAll = false;
    },

    setAvailableSalesCategories(state, data) {
        state.availableSalesCategories = data;
    },

    setSelectedAll(state, data) {
        state.selectedAll = data;
    },

    setOldAuditSalesCategoryValue(state, data) {
        state.oldAuditSalesCategoryValue = data;
    },
};

const actions = {
    setStockCheckAttr({ commit }, { key, value }) {
        commit(types.SET_STOCK_MOVEMENT_ATTR, { key, value });
    },

    addStockMovementProduct({ commit }, { stock }) {
        const stock_movement_product = {
            name: stock.name,
            sku: stock.sku,
            code: stock.code,
            stock_id: stock.id,
            stock: stock,
            quantity_before: stock.quantity,
            quantity_after: null,
            stock_movement_product_details: [],
            stock_movement: {
                status: 1,
            },
            supplier_price: stock.cost,
            rsp: null,
        };

        commit(types.ADD_STOCK_MOVEMENT_PRODUCT, stock_movement_product);
    },

    updateStockMovementProduct({ commit, getters }, { stock_id, attr, value }) {
        const stockIndex = getters.findStockIndex(stock_id);
        commit(types.UPDATE_STOCK_MOVEMENT_PRODUCT, {
            stockIndex,
            attr,
            value,
        });
    },

    removeStockMovementProduct({ commit, getters }, stock_id) {
        const stockIndex = getters.findStockIndex(stock_id);

        if (stockIndex >= 0) {
            commit(types.REMOVE_STOCK_MOVEMENT_PRODUCT, stockIndex);
            EventStock.$emit('remove-stock-id', stock_id);
        }
    },

    removeStockMovementProductDetail({ commit, state }, variance) {
        commit(types.REMOVE_STOCK_MOVEMENT_PRODUCT_DETAIL, variance);
    },

    saveStockMovementProductDetail({ commit, state }, variance) {
        commit(types.SAVE_STOCK_MOVEMENT_PRODUCT_DETAIL, variance);
    },

    enableCustomReason({ commit, state }, bool) {
        commit('setCustomReason', bool);
    },

    async createStockCheck({ commit, dispatch }, params) {
        const url = Laroute.route('inventory.stock-check.create');
        startLoading(dispatch, 'save-stock-check');

        try {
            const { data } = await axios.post(url, params);
            endLoading(dispatch, 'save-stock-check');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-stock-check');
            throw e.response.data.message;
        }
    },

    async getStockMovement({ commit, dispatch }, id) {
        const url = Laroute.route('inventory.stock-check.show', { id });
        startLoading(dispatch, 'fetch-stock-check');

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'fetch-stock-check');
            commit(types.SET_STOCK_MOVEMENT, data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-stock-check');
            throw e;
        }
    },

    async getStockMovementProduct({ commit, dispatch }, id) {
        const url = Laroute.route('inventory.stock-check.product-list', { id });
        startLoading(dispatch, 'fetch-product-list');

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'fetch-product-list');
            commit('setStockMovementProducts', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-product-list');
            throw e;
        }
    },

    async updateStockMovement({ commit, dispatch }) {
        const url = Laroute.route('inventory.stock-check.update');
        startLoading(dispatch, 'save-stock-check');
        commit('merge', state.stock_movement_products);

        try {
            const { data } = await axios.put(url, state.stock_movement);
            endLoading(dispatch, 'save-stock-check');
            commit(types.SET_STOCK_MOVEMENT, data.stock_movement);
            commit('setStockMovementProducts', data.stock_movement_products);
            EventStock.$emit('stock-list-reload');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-stock-check');
            throw e;
        }
    },

    async completed({ commit, dispatch, state }) {
        const url = Laroute.route('inventory.stock-check.completed');
        startLoading(dispatch, 'mark-completed');
        commit('merge', state.stock_movement_products);
        commit('setCommitBy');

        try {
            const { data } = await axios.post(url, state.stock_movement);
            endLoading(dispatch, 'mark-completed');
            commit(types.SET_STOCK_MOVEMENT, data.stock_movement);
            commit('setStockMovementProducts', data.stock_movement_products);

            return data;
        } catch (e) {
            commit('setResetCommit');
            endLoading(dispatch, 'mark-completed');
            throw e;
        }
    },

    async getRsp({ commit, dispatch }, { stock_id, outlet_id, code }) {
        const url = Laroute.route('inventory.stock.price-checker', {
            outlet_id: outlet_id,
            code: code,
        });
        startLoading(dispatch, 'fetch-price-checker');

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'fetch-price-checker');

            const station_unit_price = data.station_unit_price;

            dispatch('updateStockMovementProduct', {
                stock_id: stock_id,
                attr: 'rsp',
                value: station_unit_price,
            });

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-price-checker');
            throw e;
        }
    },

    async getSubUnscannedItems(
        { commit, dispatch },
        { stock_movement_id, parent_id, search },
    ) {
        const url = Laroute.route(
            'inventory.unscanned-stock.sub.unscanned.items',
            {
                stock_movement_id: stock_movement_id,
                parent_id: parent_id,
                search: search,
            },
        );

        startLoading(dispatch, 'fetch-sub-unscanned-items');

        try {
            const { data } = await axios.get(url);
            commit('setSubUnscannedItems', data);
            endLoading(dispatch, 'fetch-sub-unscanned-items');
            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-sub-unscanned-items');
            throw e;
        }
    },

    async hasUnscannedItemSession({ commit, dispatch }, id) {
        const url = Laroute.route(
            'inventory.unscanned-stock.has.unscanned.items.session',
            {
                id: id,
            },
        );

        startLoading(dispatch, 'fetch-has-unscanned-items');

        try {
            const { data } = await axios.get(url);
            commit('setHasUnscannedItems', data);
            endLoading(dispatch, 'fetch-has-unscanned-items');
            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-has-unscanned-items');
            throw e;
        }
    },

    async getStationSalesCategoryByStock(
        { commit, dispatch, getters },
        { franchise_id, outlet_id, stock_movement_id },
    ) {
        const url = Laroute.route(
            'inventory.unscanned-stock.get.station.sales.categories',
            {
                franchise_id: franchise_id,
                outlet_id: outlet_id,
                stock_movement_id: stock_movement_id,
            },
        );

        startLoading(dispatch, 'fetch-station-sales-categories');

        try {
            const { data } = await axios.get(url);
            commit('setStationStockSalesCategories', data.sales_category);
            commit('setSalesCategoryValue', { data, onLoad: true });

            const old_value = data.selected_sub_category;
            commit('setOldAuditSalesCategoryValue', old_value);

            endLoading(dispatch, 'fetch-station-sales-categories');
            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-station-sales-categories');
            throw e;
        }
    },

    async showUnscannedItems(
        { commit, dispatch, getters },
        { id, value, action, zero_system_quantity },
    ) {
        const url = Laroute.route(
            'inventory.unscanned-stock.show.unscanned.items',
        );

        let params = {
            id: id,
            value: value,
            action: action,
            old_value: getters.oldAuditSalesCategoryValue,
            zero_system_quantity,
            exclude_sales_category_id: getters.excludeSalesCategoryId,
        };

        startLoading(dispatch, 'store-unscanned-items');

        try {
            const { data } = await axios.post(url, params);
            commit(types.SET_STOCK_MOVEMENT, data);
            endLoading(dispatch, 'store-unscanned-items');
            return data;
        } catch (e) {
            endLoading(dispatch, 'store-unscanned-items');
            throw e;
        }
    },

    async saveUnscannedItems({ commit, dispatch }, payload) {
        const url = Laroute.route(
            'inventory.unscanned-stock-product.save.unscanned.items',
        );
        startLoading(dispatch, 'save-unscanned-items-payload');

        try {
            await axios.post(url, payload);
            endLoading(dispatch, 'save-unscanned-items-payload');
        } catch (e) {
            endLoading(dispatch, 'save-unscanned-items-payload');
            throw e;
        }
    },

    handleSelectedAllCheckbox({ commit, state }, data) {
        if (data == true) {
            if (
                state.checkCategoryValue.length ===
                state.availableSalesCategories.length
            ) {
                commit('setSelectedAll', data);
            }
        } else {
            commit('setSelectedAll', data);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/inventory-stock-check.js